<script lang="ts">
  import { toasts, dismissToast } from '../state/toast.svelte'

  function fire(id: number, onAction: () => void): void {
    onAction()
    dismissToast(id)
  }
</script>

<div class="toast-host" aria-live="polite">
  {#each toasts as t (t.id)}
    <div class="toast" class:has-action={!!t.action}>
      <span class="msg">{t.message}</span>
      {#if t.action}
        <button type="button" class="action" onclick={() => fire(t.id, t.action!.onAction)}>
          {t.action.label}
        </button>
      {/if}
    </div>
  {/each}
</div>

<style>
  .toast-host {
    position: fixed;
    bottom: var(--space-4);
    left: 50%;
    transform: translateX(-50%);
    z-index: 80;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    pointer-events: none;
  }
  .toast {
    display: inline-flex;
    align-items: center;
    gap: var(--space-3);
    margin: 0;
    padding: 8px 14px;
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    font-size: var(--text-sm);
    color: var(--text-primary);
  }
  .toast.has-action {
    pointer-events: auto;
  }
  .msg {
    white-space: nowrap;
  }
  .action {
    appearance: none;
    border: none;
    background: transparent;
    padding: 2px 6px;
    border-radius: var(--radius-sm);
    font: inherit;
    font-size: var(--text-sm);
    font-weight: 600;
    color: var(--accent);
    cursor: pointer;
  }
  .action:hover {
    background: var(--accent-soft);
  }
  .action:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 1px;
  }
</style>
